const doc = [({"da":({"js":({"classSteps":({"select":({"choose_class_step":"Vælg klassetrin"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;